module.exports = __webpack_public_path__ + "img/catchcopy-2.7d75ed50.png";